import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { onMounted, onUnmounted } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import ToastStack from '@/components/ToastStack.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const authStore = useAuthStore();
        onMounted(() => {
            authStore.setupAuthListener();
        });
        onUnmounted(() => {
            authStore.cleanupAuthListener();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(IonApp), null, {
                default: _withCtx(() => [
                    _createVNode(_unref(IonRouterOutlet)),
                    _createVNode(ToastStack)
                ]),
                _: 1
            }));
        };
    }
});
